import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueProgressBar from 'vue-progressbar'
import 'fullpage.js/vendors/scrolloverflow.min'
import VueFullPage from 'vue-fullpage.js'
import cloudinary from 'cloudinary-core/cloudinary-core-shrinkwrap.min.js'
import './styles/styles.scss'

Vue.use(VueProgressBar, {
  position: 'absolute',
  location: 'bottom',
  thickness: '1px',
  color: '#bbb'
})

Vue.config.productionTip = false
Vue.use(VueFullPage)

export const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
  api_key: process.env.VUE_APP_CLOUDINARY_API_KEY,
  api_secret: process.env.VUE_APP_CLOUDINARY_SECRET,
  secure: true
})

document.addEventListener('DOMContentLoaded', function () {
  cl.responsive()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
